/**
 * The canonical support/concierge contact address for the product. Import
 * this constant rather than repeating the literal, so surfaces cannot
 * drift apart on the address — the failure mode it exists to prevent. The
 * shipped surfaces (`SupportPage`, `ConciergeCard`, `ConciergeEnquiryPage`)
 * use it.
 *
 * This is a build-time, guest-facing `mailto:` literal, identical in every
 * environment. It is deliberately distinct from the backend's
 * `SUPPORT_EMAIL` (see `backend/services/notification.py`'s
 * `resolve_support_email()`), which is resolved per-environment and is
 * where mail the service actually sends is routed. The two values are not
 * a drift to be "fixed" by consolidating them — see
 * `resolve_support_email()`'s docstring for the same cross-reference from
 * the other side.
 */
export const SUPPORT_EMAIL = 'support@belhop.co';

/**
 * The canonical legal-notices contact address (disputes, notices under the
 * Terms of Service). Import this constant rather than repeating the
 * literal, so surfaces cannot drift apart on the address — the failure mode
 * it exists to prevent. Used for `mailto:` hrefs on inline links in the
 * legal content modules (`frontend/src/content/legal/`); the visible link
 * text is the verbatim transcription of the source document, which equals
 * this literal, so there is no fidelity conflict with the transcribed copy.
 *
 * This is a build-time, guest-facing `mailto:` literal, identical in every
 * environment — the same distinction from any backend-resolved address
 * applies here as documented on `SUPPORT_EMAIL` above.
 */
export const LEGAL_EMAIL = 'legal@belhop.co';

/**
 * The canonical privacy-questions and data-rights-request contact address.
 * Import this constant rather than repeating the literal, so surfaces
 * cannot drift apart on the address — the failure mode it exists to
 * prevent. Used for `mailto:` hrefs on inline links in the legal content
 * modules (`frontend/src/content/legal/`); the visible link text is the
 * verbatim transcription of the source document, which equals this
 * literal, so there is no fidelity conflict with the transcribed copy.
 *
 * This is a build-time, guest-facing `mailto:` literal, identical in every
 * environment — the same distinction from any backend-resolved address
 * applies here as documented on `SUPPORT_EMAIL` above.
 */
export const PRIVACY_EMAIL = 'privacy@belhop.co';
